module.exports = __webpack_public_path__ + "img/专利有效数图标.fd0c2c1c.png";